import { render, staticRenderFns } from "./order-control.vue?vue&type=template&id=334e4609&scoped=true&"
import script from "./order-control.vue?vue&type=script&lang=js&"
export * from "./order-control.vue?vue&type=script&lang=js&"
import style0 from "./order-control.vue?vue&type=style&index=0&id=334e4609&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334e4609",
  null
  
)

export default component.exports